export const ENDPOINTS = {
  GET_PROJECTS: '/api/projects',
  GET_PROJECT_DETAILS: '/api/projects/:id',
  GET_STAKING_ENABLE: '/api/staking',
  GET_CALENDAR: '/api/calendar',
  GET_KYC:'/api/kycs'
};
